<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>

<div class="content-page bg-gray">
    <!-- breadcrumb  & data creation-->
    <section class="d-flex align-items-center justify-content-between">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                @if (isQuote) {
                    <li class="breadcrumb-item"><a [routerLink]="['/quotes']">{{words[language][ 'quotes' ] }}</a></li>
                }
                @else {
                    <li class="breadcrumb-item"><a [routerLink]="['/sales']">{{words[language][ 'sales' ] }}</a></li>
                }
                <li class="breadcrumb-item active" aria-current="page">{{title()}}</li>
            </ol>
        </nav>
        <div class="actions text-right">
            @if (!locked && saleId && security.permitted('sales', 'sale detail', 'delete')) {
                <button class="btn btn-sm btn-danger" (click)="discard()">Delete</button>
            }
            @if (saleId && security.permitted('sales', 'sale detail', 'update')) {
                <button class="btn btn-sm" [class.btn-danger]="locked" [class.btn-secondary]="!locked" (click)="lockUnlock($event)">
                    <span [class.dripicons-lock]="locked" [class.dripicons-lock-open]="!locked"></span>
                    {{locked ? 'Unlock' : 'Lock'}}
                </button>
            }
            @if (saleId && isQuote && security.permitted('sales', 'sale detail', 'update')) {
                <button class="btn btn-sm btn-success" (click)="promote()">Promote to Sale</button>
            }
            @if (saleId && !quote && saleType == 4) {
                <button class="btn btn-sm btn-info" [routerLink]="['/sales', saleId, 'insurance']">{{words[language]['insurance']}}</button>
            }
            @if (!saleId) {
                <button class="btn btn-sm btn-link" (click)="cancel()"><span class="text-muted">Cancel</span></button>
            }
        </div>
    </section>

    @if (saleId > 0) {
        <section class="sticky-toolbar rounded">
            <div class="card">
                <div title="Show Alerts & Notes">
                    <notes [module]="'sales'" [saleId]="saleId" title="Show Alerts & Notes"></notes>
                </div>
            </div>
        </section>
    }

    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a href="#" id="sale-detail-link" data-toggle="tab" data-target="#sale-detail-tab" class="nav-link active">
                @if (isQuote) {
                    {{words[language][ 'Quote' ] }}
                }
                @else {
                    {{words[language][ 'Sale' ] }}
                }
            </a>
        </li>
        @if (saleId && saleId > 0) {
            <li class="nav-item">
                <a href="#" id="print-center-link" data-toggle="tab" data-target="#print-center-tab" class="nav-link"><span class="material-icons">print</span> Print Center</a>
            </li>
            <li class="nav-item">
                <a href="#" id="sale-admin-link" data-toggle="tab" data-target="#sale-admin-tab" class="nav-link"><span class="material-icons">settings</span> Admin</a>
            </li>
        }
    </ul>
    <div class="tab-content">
        <section class="tab-pane fade show active" id="sale-detail-tab">
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="form">
                        <div class="form-row">
                            <div class="col">
                                <div class="input-group input-group-sm">
                                    <input type="date" class="form-control form-control-sm" formControlName="saleDate" autocomplete="off" />
                                    <div class="input-group-append"><span class="input-group-text text-muted">sale date</span></div>
                                </div>

                            </div>
                            @if (isQuote) {
                                <div class="col">
                                    <div class="input-group input-group-sm">
                                        <input type="date" class="form-control form-control-sm" id="quoteExpires" formControlName="expires" autocomplete="off" />
                                        <div class="input-group-append"><span class="input-group-text text-muted">expires</span></div>
                                    </div>
                                </div>
                            }
                            <div class="col">
                                <div class="input-group input-group-sm">
                                    <select class="form-control form-control-sm" id="saleType" formControlName="type">
                                        @for (id of saleTypeKeys; track id) {
                                            <option [value]="id">{{saleTypes[id]}}</option>
                                        }
                                    </select>
                                    @if (bhph) {
                                        <div class="input-group-append">
                                            <select class="form-control form-control-sm" id="taxMethod" formControlName="taxMethod">
                                                @for (method of taxMethodKeys; track method) {
                                                    <option [value]="method">{{taxMethods[method]}}</option>
                                                }
                                            </select>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-6">
                    <buyer [language]="language" [isUnLock]="!locked"></buyer>
                </div>

                <div class="col-12 col-xl-6">
                    <stock [isLocked]="locked" [isQuote]="isQuote"></stock>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <contract [isUnLock]="!locked" [saleId]="saleId" [saleType]="saleType" [presets]="salePresets" [isQuote]="isQuote"></contract>
                </div>

                <terms [saleId]="saleId" [saleType]="saleType" [presets]="salePresets" [lastDeferredPayment]="soldOrLastDeferDate" [isUnLock]="!locked"></terms>
            </div>
        </section>

        @if (saleId && saleId > 0) {
            <section class="tab-pane" id="print-center-tab">
                <print-center [saleId]="saleId"></print-center>
            </section>
            <section class="tab-pane" id="sale-admin-tab">
                <internal-administration [sale]="sale" [locked]="locked" [bhph]="bhph" [defaultCollectionMethod]="defaultCollectionMethod"></internal-administration>
            </section>
        }
    </div>
</div>

